import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

// "No Data" placeholder for an empty cell (a span: cells may wrap it in a <p>;
// #686B72 keeps 4.5:1 contrast on the white and the hovered row)
export const NoData = ({ text }) => {
  const { t } = useTranslation();
  return (
    <Typography component="span" sx={{ color: "#686B72" }}>
      {text || t("noData")}
    </Typography>
  );
};
